import { render, staticRenderFns } from "./TotalExpenseByPeriod.vue?vue&type=template&id=3958ae94&"
import script from "./TotalExpenseByPeriod.vue?vue&type=script&lang=js&"
export * from "./TotalExpenseByPeriod.vue?vue&type=script&lang=js&"
import style0 from "./TotalExpenseByPeriod.vue?vue&type=style&index=0&id=3958ae94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports